import { usePageTitle } from '@app/hooks/usePageTitle';
import TradersWidget from '@widgets/trades/traders';

const TradersPage = () => {
  usePageTitle('Traders');

  return <TradersWidget />;
};

export default TradersPage;
